function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "./style/index.css";
import Pagination from "../Pagination";
import { DndContext, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { restrictToHorizontalAxis, restrictToVerticalAxis } from '@dnd-kit/modifiers';
import { arrayMove, horizontalListSortingStrategy, SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { Spin } from 'antd';
import cx from 'classnames';
import { isUndefined, map } from 'lodash-es';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import SortableItem from "./SortableItem";
function List(props) {
  var _props$dragKey = props.dragKey,
    dragKey = _props$dragKey === void 0 ? 'id' : _props$dragKey,
    errorComponent = props.errorComponent,
    loadingComponent = props.loadingComponent,
    _props$status = props.status,
    status = _props$status === void 0 ? 'normal' : _props$status,
    _props$pagination = props.pagination,
    pagination = _props$pagination === void 0 ? {} : _props$pagination,
    sortableComponent = props.sortableComponent,
    dndContextProps = props.dndContextProps,
    _props$listDirection = props.listDirection,
    listDirection = _props$listDirection === void 0 ? 'vertical' : _props$listDirection,
    _props$sortable = props.sortable,
    sortable = _props$sortable === void 0 ? true : _props$sortable,
    extraParams = props.extraParams,
    onDragEnd = props.onDragEnd,
    data = props.data,
    component = props.component,
    emptyComponent = props.emptyComponent,
    className = props.className,
    style = props.style;
  var topRef = useRef(null);
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    dataSource = _useState2[0],
    setDataSource = _useState2[1];
  var sensors = useSensors(useSensor(PointerSensor, {
    activationConstraint: {
      // https://docs.dndkit.com/api-documentation/sensors/pointer#activation-constraints
      distance: 1
    }
  }));
  var handleDragEnd = useCallback(function (event) {
    var active = event.active,
      over = event.over;
    var ids = dataSource.map(function (item) {
      return item[dragKey];
    });
    var oldIndex = ids.indexOf(active === null || active === void 0 ? void 0 : active.id);
    var newIndex = ids.indexOf(over === null || over === void 0 ? void 0 : over.id);
    if ((active === null || active === void 0 ? void 0 : active.id) !== (over === null || over === void 0 ? void 0 : over.id)) {
      var dragRes = arrayMove(dataSource, oldIndex, newIndex);
      onDragEnd === null || onDragEnd === void 0 || onDragEnd(dragRes.map(function (item, index) {
        return _objectSpread(_objectSpread({}, item), {}, {
          index: index
        });
      }), extraParams);
      setDataSource(dragRes);
    }
  }, [dataSource, extraParams]);
  useEffect(function () {
    if (Array.isArray(data)) {
      setDataSource(data);
    }
  }, [data]);
  var renderListByStatus = function renderListByStatus() {
    if (status === 'loading') {
      return /*#__PURE__*/React.createElement("div", null, loadingComponent || /*#__PURE__*/React.createElement(Spin, null));
    }
    if (status === 'error') {
      return /*#__PURE__*/React.createElement("div", null, errorComponent || /*#__PURE__*/React.createElement("div", null, "\u53D1\u751F\u9519\u8BEF"));
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "dr-list__inner",
      ref: topRef
    }, Array.isArray(dataSource) && /*#__PURE__*/React.createElement(DndContext, _extends({}, dndContextProps, {
      sensors: sensors,
      modifiers: [listDirection === 'vertical' ? restrictToVerticalAxis : restrictToHorizontalAxis],
      onDragEnd: handleDragEnd
    }), /*#__PURE__*/React.createElement(SortableContext, {
      items: dataSource.map(function (c) {
        return c[dragKey];
      }),
      strategy: listDirection === 'vertical' ? verticalListSortingStrategy : horizontalListSortingStrategy
    }, dataSource.length === 0 ? emptyComponent === null || emptyComponent === void 0 ? void 0 : emptyComponent() : /*#__PURE__*/React.createElement(React.Fragment, null, map(dataSource, function (item, index) {
      return /*#__PURE__*/React.createElement("div", {
        className: "dr-list__item",
        key: item[dragKey]
      }, /*#__PURE__*/React.createElement(SortableItem, {
        sortableComponent: sortableComponent,
        disabled: !sortable || item.disabled,
        id: item[dragKey],
        key: item[dragKey]
      }, /*#__PURE__*/React.createElement("div", {
        "data-id": item[dragKey],
        key: item[dragKey]
      }, component === null || component === void 0 ? void 0 : component(item, index))));
    }))))), pagination && /*#__PURE__*/React.createElement("div", {
      className: "dr-list__pagination"
    }, /*#__PURE__*/React.createElement(Pagination, _extends({}, pagination, {
      position: pagination.position || 'center',
      total: pagination.total || data.length || 0,
      showTotal: pagination.showTotal || false,
      onChange: function onChange(page, pageSize) {
        var _pagination$onChange;
        var scrollToTop = isUndefined(pagination.scrollToTop) ? true : pagination.scrollToTop;
        pagination === null || pagination === void 0 || (_pagination$onChange = pagination.onChange) === null || _pagination$onChange === void 0 || _pagination$onChange.call(pagination, page, pageSize);
        if (scrollToTop) {
          var _topRef$current;
          // 点击翻页后返回顶部
          (_topRef$current = topRef.current) === null || _topRef$current === void 0 || _topRef$current.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        }
      }
    }))));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: cx('dr-list', "dr-list-".concat(listDirection), "dr-list-".concat(status), className),
    style: style
  }, renderListByStatus());
}
export default List;